import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Record } from 'src/app/models/record';
import { Util } from 'src/app/util';
import { BaseButtonComponent } from '../base-button';

@Component({
  selector: 'app-view-all-button',
  templateUrl: './view-all-button.component.html',
  styleUrls: ['./view-all-button.component.scss'],
})
export class ViewAllButtonComponent extends BaseButtonComponent {
  @Output()
  clicked: EventEmitter<void> = new EventEmitter();

  ngOnInit() {}

  handleClick() {
    if (!this.router.url.includes('/info/')) {
      this.router.navigate([this.getRecordUrl(this.record)]);
      return;
    }

    document.getElementById('container-record-items-anchor').scrollIntoView({
      behavior: 'smooth',
    });

    this.clicked.emit();
  }

  getRecordUrl(record: Record): string {
    return '/info/' + Util.slugifyRecord(record);
  }
}
